import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "antd";
import ErrorImg from "@/Assets/Images/Error.png";

const { Title, Text } = Typography;

export default function FallbackUIComponent() {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "100px",
      }}
    >
      <br />
      <img src={ErrorImg} alt="error" style={{ width: "200px" }} />
      <br />
      <Title level={1} type="danger">
        {t("common.FallbackUiComponent.Oops! Something went wrong.")}
      </Title>
      <br />
      <Title level={4} type="warning">
        {t("common.FallbackUiComponent.Let's try that again, please refresh the page.")}
      </Title>
      <Text type="warning">
        {t("common.FallbackUiComponent.If you're still stuck, contact us by chat support or")} &nbsp;
        <a href="mailto:support@webrexstudio.com" target="_blank" rel="noopener noreferrer">
          {t("common.FallbackUiComponent.support@webrexstudio.com")}
        </a>
        &nbsp;{t("common.FallbackUiComponent.so we can help!")}
      </Text>
    </div>
  );
}
